export default {
      id: "icon-Android-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-Android",
      toString: function () {
        return this.url;
      }
    }